<template>
  <div>
    <a-modal
        v-drag-modal
        wrap-class-name="custom-modal-wrap" v-model="localVisible" :confirmLoading="loading" :maskClosable="false" @cancel="cancel" @ok="confirm">
      <div slot="title">{{ innerForm.id ? '编辑账号' : '新增账号' }}</div>
      <div>
        <a-form-model ref="form" :model="innerForm" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="username" label="用户名">
            <a-input v-model="innerForm.username" />
          </a-form-model-item>
          <a-form-model-item prop="name" label="员工姓名">
            <a-input v-model="innerForm.name" />
          </a-form-model-item>
          <a-form-model-item prop="phone" label="手机号">
            <a-input v-model="innerForm.phone" />
          </a-form-model-item>
          <a-form-model-item prop="email" label="邮箱">
            <a-input v-model="innerForm.email" />
          </a-form-model-item>
          <a-form-model-item prop="sex" label="性别">
            <a-select default-value="man" style="width: 100%" v-model="innerForm.sex">
              <a-select-option value="man"> 男 </a-select-option>
              <a-select-option value="woman"> 女 </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="is_active" label="状态">
            <a-select v-model="innerForm.is_active" style="width: 100%;">
              <a-select-option :value="true">启用</a-select-option>
              <a-select-option :value="false">禁用</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="roles" label="角色">
            <a-select v-model="innerForm.roles" mode="multiple" allowClear style="width: 100%;">
              <a-select-option v-for="item in roleItems" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>

        <div v-if="!innerForm.id" style="color: rgb(255, 77, 79); text-align: center;">
          默认初始密码为: 123456, 登录后请修改密码
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import { userCreate, userUpdate } from '@/api/account'
  import rules from './rules.js'

  export default {
    name: 'FormModal',
    model: { prop: 'visible', event: 'cancel' },
    props: {
      visible: { type: Boolean, default: false },
      form: { type: Object, default: () => ({}) },
      roleItems: { type: Array, default: () => [] },
    },
    data() {
      return {
        rules,
        loading: false,
        localVisible: this.visible,
        innerForm: this.cloneForm(this.form),
      };
    },
    watch: {
      visible(v) {
        this.localVisible = v;
        if (v) this.innerForm = this.cloneForm(this.form);
      },
      form(v) {
        this.innerForm = this.cloneForm(v);
      },
    },
    methods: {
      cloneForm(src) {
        return JSON.parse(JSON.stringify(src || {}));
      },
      confirm() {
        this.$refs.form.validate(valid => {
          if (!valid) return;
          this.loading = true;
          const payload = { ...this.innerForm };
          const func = payload.id ? userUpdate : userCreate;
          func(payload).then(data => {
            this.$message.success(payload.id ? '修改成功' : '新增成功');
            this.$emit(payload.id ? 'update' : 'create', data);
            this.cancel();
          }).finally(() => {
            this.loading = false;
          });
        });
      },
      cancel() {
        this.$emit('cancel', false);
        if (this.$refs.form) this.$refs.form.resetFields();
      },
    },
  }
</script>

<style scoped>
</style>
